import { IconButton, InputAdornment } from '@mui/material'
import { VisibilityOffOutlined, VisibilityOutlined } from '@mui/icons-material'
import { EyeClosedIcon } from 'src/assets/icons/v2/EyeClosedIcon'
import { EyeOpenedIcon } from 'src/assets/icons/v2/EyeOpenedIcons'

interface IShowPasswordIconProps {
  onClick: () => void
  showPassword: boolean
}

const ShowPassowrdIcon = ({ onClick, showPassword }: IShowPasswordIconProps) => {
  return (
    <InputAdornment style={{ zIndex: 2 }} position="end">
      <IconButton size="small" aria-label="toggle password visibility" onClick={onClick}>
        {showPassword ? <EyeClosedIcon size={24} /> : <EyeOpenedIcon size={24} />}
      </IconButton>
    </InputAdornment>
  )
}

export { ShowPassowrdIcon }
